import { createAccountInput, CreateAccountValidatorProps } from "../../../types/types";


export class CreateAccountValidator{
    validateAccountInfo(inputs:createAccountInput, props: CreateAccountValidatorProps){
      let isFormValidated = true;

      if (!inputs.nameOfAccountHolder) {
        props.formValidation.nameOfAccountHolder = {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }

      
      if (!inputs.bankAccountNumber) {
        props.formValidation.bankAccountNumber= {
          message: "This field is required.",
          isValidated: true,
        }

        isFormValidated = false;
      }
      
      if (!inputs.confirmBankAccountNumber) {
        props.formValidation.confirmBankAccountNumber= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      } else if (inputs.bankAccountNumber !== inputs.confirmBankAccountNumber) {
        props.formValidation.confirmBankAccountNumber= {
          message: "Incorrect account number.",
          isValidated: true,
        }
        isFormValidated = false;  
        
      }
  
      if (!inputs.ifsc) {
        props.formValidation.ifsc= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
  
      if (!inputs.pinCode) {
        props.formValidation.pinCode= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
      else if(!(/^[0-9]{6}$/i.test(inputs.pinCode))){
        props.formValidation.pinCode = {
          message: "Please enter a valid pincode",
          isValidated: true,
        }
        isFormValidated = false;
      }
  
      if (!inputs.addressLine1) {
        props.formValidation.addressLine1= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
  
      if (!inputs.addressLine2) {
        props.formValidation.addressLine2= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }

      if (!inputs.mobile) {
        props.formValidation.mobile= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
      else if(!(/^[0-9]{10}$/i.test(inputs.mobile))){
        props.formValidation.mobile = {
          message: "Please enter a valid mobile number",
          isValidated: true,
        }
        isFormValidated = false;
      }
  
      if (!inputs.email) {
        props.formValidation.email= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
      else if(!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(inputs.email))){
        props.formValidation.email = {
          message: "Please enter a valid email",
          isValidated: true,
        }
        isFormValidated = false;
      }
  
      if (!inputs.pan) {
        props.formValidation.pan= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
  
      if (!inputs.gstin) {
        props.formValidation.gstin= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
      else if(inputs.gstin.length > 16){
        props.formValidation.gstin = {
          message: "Limit exceeded",
          isValidated: true,
        }
        isFormValidated = false;
      }

      if (!inputs.checkLeafURL) {
        props.formValidation.checkLeafURL= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }

      if (!inputs.authorizationLetter) {
        props.formValidation.authorizationLetter= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }

      if (!inputs.bankName) {
        props.formValidation.bankName= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }
      
      if (!inputs.constitution) {
        props.formValidation.constitution= {
          message: "This field is required.",
          isValidated: true,
        }
        isFormValidated = false;
      }

      props.setFormValidation((prevState)=>{
        return {
              ...prevState,
              ...props.formValidation
            };
      })
      return isFormValidated;
    };
}
